import { createSlice,createAsyncThunk } from '@reduxjs/toolkit'
import {getHomeList} from '@/api/index.js'


const initialState = {
    homeList:{
        news_list:[],
        fair_list:[],
        video_list:[],
        company_list:[],
        technology_list:[],
        news_list_not_image:[],
        technology_list_not_image:[]
    },
}
//获取首页新闻
export const getHomeListThunk = createAsyncThunk('news/getType', async (param={}) => {
    const payload = await getHomeList(param)
    return payload
})

// 获取首页视频第一页
// export const getIndexVideo = createAsyncThunk('news/getIndexVideo', async (param) => {
//     const payload = await getVideo({page:1,number:5})
//     return payload
// })


export const homeSlice = createSlice({
  name: 'home',
  initialState,
  reducers: {
   
  },
  extraReducers: (builder) => {
    builder
        .addCase(getHomeListThunk.fulfilled, (state, { payload }) => {
            payload.errcode===200&&(state.homeList = payload.data);
        })
        // .addCase(getIndexVideo.fulfilled, (state, { payload }) => {
        //     // console.log(payload)
        //     if(payload.errcode===200){
        //         state.indexVideoList = payload.data.video_list;
        //          //首页获取视频新闻第一页，如果此时视频页面没数据，可以填充给视频页面
        //         if(JSON.stringify(state.videoList) === "{}"){
        //             state.videoList = payload.data;
        //         }
        //     }
        // })
    }
})

// Action creators are generated for each case reducer function
// export const { setUser,setCollect,setToken,openLoginBox,closeLoginBox } = homeSlice.actions

export default homeSlice.reducer